import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth-service/auth.service';
import { MatDialog } from '@angular/material';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { FormUtils } from '../../utilities/FormUtils/FormUtils';
import { CompanyService } from '../../services/company-service/company.service';
import { CONSTANTS } from '../../utilities/Constants';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css']
})
export class AdminLoginComponent implements OnInit {

  email;
  password;
  showPassword = false;
  recoverPassword;
  recoveryForm: FormGroup;
  passwordInvalid;
  mobile = false;
  constructor(
    private main: MainService,
    private authService: AuthService,
    private dialog: MatDialog, 
    private router: Router, 
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.mobile = window.outerWidth < 1000 ? true : false;
    if (this.route.snapshot.queryParams.reset) {
      this.forgotPassword();
    }
  }

  login() {

    this.authService.adminLogin(this.email, this.password).then((result: any) => {

      if (result.status) {
        localStorage.clear();
        localStorage.setItem('token', result.data.token);
        this.authService.saveAdminPayload(result.data.payload);
        sessionStorage.setItem('sidebarstate', 'closed');
        const landing = this.getPostLoginLanding(result.data.payload);
        this.router.navigate([landing]);
      } else {
        new QuickDialog(this.dialog).InfoDialog(result.message, "Login Error", "OK");
      }
    }).catch(e => {
      new QuickDialog(this.dialog).InfoDialog("Check you email and password", "Login Error", "OK");
    });
  }

  backToLogin() {
    this.recoverPassword = false;
  }

  passwordValid() {
    var form = this.recoveryForm.getRawValue();
    if (form.password != null) {
      if (form.password.length < 6) {
        this.passwordInvalid = "Password must be 6 or more characters";
        return false;
      }
      else if (form.password != form.confirmpass) {
        this.passwordInvalid = "Password and confirm password fields must match";
        return false;
      }
    } else {
      this.passwordInvalid = "Please enter a password";
      return false;
    }
    return true;
  }

  resetPassword() {
    FormUtils.markFormGroupTouched(this.recoveryForm);
    if (this.recoveryForm.valid) {
      var form = this.recoveryForm.getRawValue();
      this.main.adminReset(form.recoveryEmail, form.password, form.recoveryCode).then((res) => {
        new QuickDialog(this.dialog).InfoDialog("Your password has been updated, return to login", "Updated", "OK").then(() => {
          this.backToLogin()
        })
      }).catch(e => {
        new QuickDialog(this.dialog).InfoDialog("Expired/Invalid Code Or Unknown Account", "Error", "OK");
      })
    }
  }

  sendCode() {
    this.recoveryForm.get('recoveryEmail').markAsTouched();
    if (this.recoveryForm.get('recoveryEmail').valid) {
      this.main.sendAdminRecovery(this.recoveryForm.getRawValue().recoveryEmail).then((res) => {
        new QuickDialog(this.dialog).InfoDialog("Enter the code in the form below to reset your password.", "Sent", "OK");
      }).catch(e => {
        new QuickDialog(this.dialog).InfoDialog("There was an issue sending the code.", "Error", "OK");
      })
    }
  }

  forgotPassword() {
    this.recoverPassword = true;
    this.recoveryForm = new FormGroup({
      recoveryEmail: new FormControl('', [Validators.required, Validators.email]),
      recoveryCode: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      confirmpass: new FormControl('', [Validators.required]),
    })
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  /** Customer Care / CUSTOMERS-only users go straight to Customer List. */
  private getPostLoginLanding(payload: any): string {
    if (this.shouldLandOnCustomers(payload)) {
      return '/admin-portal/customers';
    }
    return '/admin-portal/dashboard';
  }

  private shouldLandOnCustomers(payload: any): boolean {
    if (!payload) {
      return false;
    }
    if (payload.roles_map && payload.roles_map[CONSTANTS.ROLE_TYPE_CUSTOMER_CARE]) {
      return true;
    }
    const features = payload.feature_access || [];
    if (!features.length) {
      return false;
    }
    return features.every((row: any) => row && row.feature === 'CUSTOMERS');
  }

}
